import { userService } from '../../helpers/authservice/user.service';

export const actions = {
    storeUser({ dispatch, commit }, payload) {
        return new Promise((resolve, reject) => {
            userService.save(payload).then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
    updateUser({ dispatch, commit }, payload) {
        return new Promise((resolve, reject) => {
            userService.update(payload).then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
    viewUser({ dispatch, commit }, payload) {
        return new Promise((resolve, reject) => {
            userService.get(payload).then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
    allUser({ dispatch, commit }, payload) {
        return new Promise((resolve, reject) => {
            userService.getAll(payload).then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
    removeUser({ dispatch, commit }, payload) {
        return new Promise((resolve, reject) => {
            userService.remove(payload).then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
    changePassword({ dispatch, commit }, payload) {
        return new Promise((resolve, reject) => {
            userService.changePassword(payload).then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
    profile({ dispatch, commit }) {
        return new Promise((resolve, reject) => {
            userService.profile().then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
    resetPass({ dispatch, commit }, email) {
        return new Promise((resolve, reject) => {
            userService.resetPass(email).then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
    confirmPass({ dispatch, commit }, payload) {
        return new Promise((resolve, reject) => {
            userService.confirmPass(payload).then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
}

export const mutations = {

};

function _handleError(error) {
    var errorMessage = error.response ? error.response.statusText : error;
    return errorMessage;
};